/*** IMPORTS FROM imports-loader ***/
var _ = require("underscore/underscore");

module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p +=
((__t = ( begin_tab('Details', {open: true, html_options: {'class': 'details-tab'}}))) == null ? '' : __t) +
'\n\n' +
((__t = ( end_tab())) == null ? '' : __t) +
'\n' +
((__t = ( begin_tab('Permissions', {html_options: {'class': 'permissions-tab'}}))) == null ? '' : __t) +
'\n' +
((__t = ( end_tab())) == null ? '' : __t) +
'\n';
 if(!model.get('external')){;
__p += '\n' +
((__t = ( begin_tab('Layers', {html_options: {'class': 'layers-tab'}}))) == null ? '' : __t) +
'\n' +
((__t = ( end_tab())) == null ? '' : __t) +
'\n';
};


}
return __p
}



//////////////////
// WEBPACK FOOTER
// ./public/views/admin/mapServices/Details.ejs
// module id = 927
// module chunks = 1